import { Model } from "pinia-orm";
import { CertificationProject, ExaminationDecision, Step } from "@/models";
import { RECEIVABILITY_STATUS } from "@/models/enums/receivabilityStatus";

export default class CertificationProjectStep extends Model {
  static entity = "certificationProjectSteps";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      createdAt: this.string(""),
      updatedAt: this.string(""),
      receivabilityStatus: this.string(RECEIVABILITY_STATUS.PENDING),
      isValidated: this.boolean(false),
      startDate: this.string(""),
      endDate: this.string(""),

      // Foreign keys
      certificationProjectUuid: this.string(""),
      certificationProjectData: this.belongsTo(CertificationProject, "certificationProjectUuid"),
      stepUuid: this.string(""),
      stepData: this.belongsTo(Step, "stepUuid"),
      examinationDecisions: this.hasMany(ExaminationDecision, "certificationProjectStepUuid"),

      // Other
      userUuid: this.string(""),
      isDisplayed: this.boolean(false),
    };
  }
}
